export default __webpack_public_path__ + "static/media/zm.d27df652.jpg";